import React from "react";
import { CircularProgress } from "@material-ui/core";
import { LoadingWrapper } from "../styles";
var ContentLoader = function (_a) {
    var height = _a.height, size = _a.size;
    return (React.createElement(LoadingWrapper, { height: height },
        React.createElement(CircularProgress, { size: size ? size : "7rem", color: "primary", thickness: 5, variant: "indeterminate" })));
};
export default ContentLoader;
//# sourceMappingURL=ContentLoader.js.map